import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-brand">
          <h2>SNTE - Sistema de Gestión</h2>
        </div>
        <div className="navbar-user">
          <span className="user-info">
            <strong>{user?.nombre}</strong>
            <span className="user-role">({user?.role})</span>
            {user?.coordinacion && (
              <span className="user-coordinacion"> - {user.coordinacion.nombre}</span>
            )}
          </span>
          <button onClick={handleLogout} className="btn btn-secondary btn-sm">
            Cerrar Sesión
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
